import { Text } from "@ecco/ui/text";
import { Box } from "@ecco/ui/box";
import { CommonCMS } from "@lib/constants/contentful";
import { BoxWithRibbon } from "../BoxWithRIbbon";
import { hasPointsAndTiers } from "@lib/utils/loyalty";

const PendingEmailVerification = ({ microcopies, email }) => {
    return (
        <BoxWithRibbon>
            <Box padding={[6, 8]}>
                <Text fontWeight="bold" fontSize="desktopH2">
                    {microcopies[CommonCMS.loyalty.emailVerification.emailSent]}
                </Text>
                <Text marginTop={[1, 2]}>
                    {microcopies[CommonCMS.loyalty.emailVerification.verifyEmailToGetAccess]}
                </Text>
                {email && (
                    <Text fontWeight="bold" marginTop={[1, 2]}>
                        {email}
                    </Text>
                )}
                <Box display={"flex"} flexDirection={"row"} gap={2} marginTop={[3, 5]}>
                    {hasPointsAndTiers && (
                        <Text fontWeight={"semibold"}>
                            {microcopies[CommonCMS.loyalty.tierLevel]}
                        </Text>
                    )}
                    {hasPointsAndTiers && (
                        <Text fontWeight={"semibold"}>
                            {microcopies[CommonCMS.loyalty.pointsBalance]}
                        </Text>
                    )}
                    <Text fontWeight={"semibold"}>{microcopies[CommonCMS.loyalty.eccoPass]}</Text>
                </Box>
            </Box>
        </BoxWithRibbon>
    );
};

export default PendingEmailVerification;
